import { useEffect } from 'react';

const ParallaxBackground = () => {
  useEffect(() => {
    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrolled = window.pageYOffset;
          const app = document.querySelector('.App');
          
          if (app) {
            // Subtle parallax - background moves at 30% of scroll speed
            const parallaxOffset = scrolled * 0.3;
            app.style.backgroundPositionY = `calc(50% + ${parallaxOffset}px)`;
          }
          
          ticking = false;
        });
        
        ticking = true;
      }
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return null;
};

export default ParallaxBackground;
